/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import CardProfile from '@dtvgo/card-profile';
import Icon from '@dtvgo/icon';
import InteractiveElement from '@dtvgo/interactive-element';

/* Utils */
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';

/* Styles */
import './FocusableCardProfileEdit.scss';

export function FocusableCardProfileEdit({
  className,
  focused,
  name,
  color,
  nameUser,
  onMouseDown,
  onMouseEnter,
  onClick,
  key,
}) {
  return (
    <InteractiveElement
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
      className={
      `dtv-html5-c-card-profile ${
        focused ? 'dtv-html5-c-card-profile--focused' : ''
      } ${className}`
    }
      key={key}
    >
      <div className="dtv-html5-c-profile-management__circle" />
      <Icon
        className={
        `dtv-html5-c-profile-management__edit-logo ${
          focused ? 'dtv-html5-c-profile-management__edit-logo--focused' : ''
        } ${className}`
      }
        name="edit"
      />
      <CardProfile name={name} color={color} nameUser={nameUser} onClick={onClick} />
    </InteractiveElement>
  );
}

FocusableCardProfileEdit.propTypes = {
  className: PropTypes.string,
  focused: PropTypes.bool,
  name: PropTypes.string,
  color: PropTypes.oneOf(['blue', 'green', 'lime-green', 'orange', 'red']),
  nameUser: PropTypes.bool,
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
  key: PropTypes.number,
};

FocusableCardProfileEdit.defaultProps = {
  className: '',
  focused: false,
  name: '',
  color: 'blue',
  nameUser: true,
  onClick: undefined,
  onMouseDown: undefined,
  onMouseEnter: undefined,
  key: 0,
};

export default memo(withInteractiveFocusable()(memo(FocusableCardProfileEdit)));
